import { useRef } from 'react';
import { motion, useMotionValue, useTransform, useAnimationFrame } from 'framer-motion';
interface AutoScrollHorizontalProps {
  speed?: number; // pixels per frame
  children: React.ReactNode;
}

const AutoScrollHorizontal = ({ speed = 0.5, children }: AutoScrollHorizontalProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollX = useMotionValue(0);

  useAnimationFrame(() => {
    const container = containerRef.current;
    if (!container) return;

    const scrollWidth = container.scrollWidth / 2;
    const x = scrollX.get();

    if (x <= -scrollWidth) {
      scrollX.set(0); // reset position smoothly
    } else {
      scrollX.set(x - speed);
    }
  });

  const x = useTransform(scrollX, (value) => `${value}px`);

  return (
    <div className="relative w-full overflow-hidden">
      <motion.div
        ref={containerRef}
        className="flex"
        style={{ x }}
      >
        <div className="flex">
          {children}
          {children}
        </div>
      </motion.div>
    </div>
  );
};

export default AutoScrollHorizontal
